/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';

/**
 * 
 * @export
 * @interface CalculateSessionRequest
 */
export interface CalculateSessionRequest {
    /**
     * 
     * @type {Date}
     * @memberof CalculateSessionRequest
     */
    currencyDate: Date;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CalculateSessionRequest
     */
    studentId?: ActorActivityRecordActorUserId | null;
}

/**
 * Check if a given object implements the CalculateSessionRequest interface.
 */
export function instanceOfCalculateSessionRequest(value: object): value is CalculateSessionRequest {
    if (!('currencyDate' in value) || value['currencyDate'] === undefined) return false;
    return true;
}

export function CalculateSessionRequestFromJSON(json: any): CalculateSessionRequest {
    return CalculateSessionRequestFromJSONTyped(json, false);
}

export function CalculateSessionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculateSessionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyDate': (new Date(json['currencyDate'])),
        'studentId': json['studentId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['studentId']),
    };
}

export function CalculateSessionRequestToJSON(json: any): CalculateSessionRequest {
    return CalculateSessionRequestToJSONTyped(json, false);
}

export function CalculateSessionRequestToJSONTyped(value?: CalculateSessionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currencyDate': value['currencyDate'].toISOString().substring(0,10),
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
    };
}

